import { Box, Button, Modal, TextField, Typography } from "@mui/material";
import React, { useState } from "react";
import { tokens } from "../../theme";
import * as yup from "yup";
import { useTheme } from "@emotion/react";
import { Formik } from "formik";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import useAuth from "../../hooks/useAuth";
import axios from "../../api/axios";
import { useNavigate } from "react-router-dom";

const FORGOT_PASSWORD_URL = "/auth-serviceV3/auth/forgot-password";

const ForgetPasswordOTPModal = ({ modal, setModal }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const axiosPrivate = useAxiosPrivate();
  const { success, snackError, setOTPEmailOrPhone } = useAuth();
  const navigate = useNavigate();

  const emailRegex =
    /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;

  const phoneRegex = /^(?:\+?234|0)?\d{10}$/; // Support multiple formats, will be normalized

  const handleFormSubmit = async (values, actions) => {
    let loginId = values.emailOrPhone;
    if (loginId.match(phoneRegex)) {
      if (loginId.startsWith("+")) {
        loginId = loginId.substring(1);
      }
      if (loginId.startsWith("0")) {
        loginId = "234" + loginId.substring(1);
      }
      if (!loginId.startsWith("234")) {
        loginId = "234" + loginId;
      }
    }

    try {
      const response = await axios.post(FORGOT_PASSWORD_URL, {
        loginId,
      });
      success(response.data.message || "OTP sent successfully");
      actions.resetForm();
      setOTPEmailOrPhone(loginId);
      navigate("/forget-password");
    } catch (error) {
      snackError(error.response?.data?.error?.message || error.response?.data?.message || "Failed to request password reset OTP");
    }
  };

  const initialValues = {
    emailOrPhone: "",
  };

  const checkoutSchema = yup.object().shape({
    emailOrPhone: yup
      .string("Enter your Login ID")
      .required("Login ID is required")
      .test("emailOrPhone", "Enter Valid Login ID (Phone/Email)", function (value) {
        if (!value) return false;
        let isValidEmail = emailRegex.test(value);
        let isValidPhone = phoneRegex.test(value);
        return isValidEmail || isValidPhone;
      }),
  });

  // Close the modal
  const handleClose = () => {
    setModal((prev) => {
      return { ...prev, open: false };
    });
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 520,
    height: 330,
    bgcolor: colors.primary[400],
    border: "1px solid #000",
    boxShadow: 24,
    p: 5,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
  };

  return (
    <Modal
      open={modal.open}
      onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box sx={style}>
        <Box mb="30px">
          <Typography
            variant="h2"
            color={colors.grey[100]}
            fontWeight="bold"
            sx={{ mb: "5px" }}
          >
            REQUEST OTP
          </Typography>
          <Typography variant="h5" color={colors.orangeAccent[600]}>
            Enter Login ID to generate OTP for forget password
          </Typography>
        </Box>
        <Formik
          onSubmit={handleFormSubmit}
          initialValues={initialValues}
          validationSchema={checkoutSchema}
        >
          {({
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
            isSubmitting,
          }) => (
            <form
              onSubmit={handleSubmit}
              style={{
                display: "flex",
                flexDirection: "column",
                width: "90%",
              }}
            >
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Login ID"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.emailOrPhone}
                name="emailOrPhone"
                error={!!touched.emailOrPhone && !!errors.emailOrPhone}
                helperText={touched.emailOrPhone && errors.emailOrPhone}
                sx={{ gridColumn: "span 16" }}
              />
              <Button
                fullWidth
                disabled={isSubmitting}
                type="submit"
                color="secondary"
                variant="contained"
                sx={{ gridColumn: "span 16", p: 2, mt: 3 }}
              >
                Submit
              </Button>
            </form>
          )}
        </Formik>
      </Box>
    </Modal>
  );
};

export default ForgetPasswordOTPModal;
